import React from "react";

function Airpods(){
    return(
        <div>
<section className="internal_wraper">
<div className="container">
<div className="row">
    <div className="col-12 mt-5 pt-5">
<h1 className="font-weight-bold">
airpods
</h1>
    </div>
</div>
</div>
</section>
        </div>
    );
};

export default Airpods;